import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3">
            帮助中心
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            关于芭乐视频平台使用的常见问题解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mt-0.5">
                    <span className="text-xs font-bold">Q</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2">
                      {item.q}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}